<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div
    class="d-flex align-center"
  >
    <slot name="navigation" />
    <div
      v-if="$slots.default"
      class="d-block overflow-hidden"
    >
      <div
        :class="!$vuetify.breakpoint.lgAndUp ? 'text-h3' : 'text-h2'"
        class="font-weight-bold text-truncate"
      >
        <slot />
      </div>
      <div
        v-if="$slots.subtitle"
      >
        <slot name="subtitle" />
      </div>
    </div>
    <v-spacer v-if="$slots.action" />
    <div v-if="$slots.action">
      <slot name="action" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageHeader'
}
</script>

<style scoped>

</style>
